import { Component, OnInit, OnDestroy, AfterViewChecked } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { CURRENCY_ITEM } from 'app/common/components/balances-item/balances-item-data';
import { IBalanceItem, ICurrencyItem } from 'app/common/components/balances-item/balances-item-interface';
import { getCookieValue } from 'app/common/utils/cookie.util';
import { AnalyticsService } from 'app/services/auth/analytics.service';
import { AuthService } from 'app/services/auth/auth.service';
import { BadgeService } from 'app/services/badge/badge.service';
import { StakingRewardsService } from 'app/services/contract/contracts-services/staking-rewards.service';
import { TokenService } from 'app/services/contract/contracts-services/token.service';
import { IUserLootboxItemsResponse, IUserNFTItemResponse } from 'app/services/user-items/user-items.interface';
import { UserItemsService } from 'app/services/user-items/user-items.service';
import { KSideMenuService } from 'app/services/k-side-menu/k-side-menu.service';
import { NavigationService } from 'app/services/navigation/navigation.service';
import { INavigationItem } from 'app/services/navigation/navigation.types';
import { ToastService } from 'app/services/toast-wrapper/toast-wrapper.service';
import { IUserData } from 'app/services/user/user.interface';
import { UserService } from 'app/services/user/user.service';
import { eStatus } from 'app/services/web3/web3.config';
import { Web3Service } from 'app/services/web3/web3.service';
import { Subscription, first, of, switchMap } from 'rxjs';
import { HttpClient } from '@angular/common/http'
import { analyticsTrack } from 'app/services/auth/analytics.service';
import { ICompanyItemsResponse, eCompanyItems } from 'app/services/companyItems/company-items.interface';
import { CompanyItemsService } from 'app/services/companyItems/company-items.service';
import { eCurrencies } from 'app/common/ui/info-icon/info-icon.interface';
import { environment } from 'environments/environment';


@Component({
  selector: 'app-user-layout',
  templateUrl: './user-layout.component.html',
  styleUrls: ['./user-layout.component.scss']
})
export class UserLayoutComponent implements OnInit, OnDestroy, AfterViewChecked {

  private navigationSubscription: Subscription;
  private menuCollapsedSubscription: Subscription;
  private userDataSubscription: Subscription;

  userData: IUserData;
  userNavigation: INavigationItem[];
  balanceItemList: Array<eCompanyItems | eCurrencies> = BALANCE_ITEM_LIST();//It is the order list of all items
  balanceItems: IBalanceItem[] = []; //used to merge and display both items and currency
  companyItems: ICompanyItemsResponse[];
  currencyItems: Map<eCurrencies, ICurrencyItem> = CURRENCY_ITEM();
  isMenuCollapsed: boolean;
  showQuickPurchase: boolean = false;
  ingameItemFocus: Map<eCompanyItems, boolean> = new Map<eCompanyItems, boolean>();
  quickPurchaseItem: ICompanyItemsResponse;
  cookieCheckInterval: NodeJS.Timeout;
  hasEarlySupportBadge: boolean = false;
  hasHunterBadge: boolean = false;
  isLoading: boolean = false;
  trainerClubId: string
  isWhitelisted: boolean = false;
  showWokBanner: boolean = false;
  showMigrationButton: boolean = false;
  hasCollectorBadge: boolean = false;

  constructor(
    private navigationService: NavigationService,
    private toastService: ToastService,
    private kSideMenuService: KSideMenuService,
    private userService: UserService,
    private authService: AuthService,
    private router: Router,
    private itemService: UserItemsService,
    private tokenService: TokenService,
    private web3Service: Web3Service,
    private stakingRewardsService: StakingRewardsService,
    private analyticsService: AnalyticsService,
    private badgeService: BadgeService,
    private http: HttpClient,
    private companyItemService: CompanyItemsService
  ) {
    this.navigationService.get();
    this.userDataSubscription = this.userService.userInfo$.subscribe(u => {
      this.userData = u;
    });
  }

  ngOnInit(): void {

    let walletProvider = getCookieValue('login');
    if(walletProvider == "magic"){
      this.showMigrationButton = true;
    }

    this.web3Service.getChainId().subscribe((chainID: number) => {
      if ([56, 97].includes(chainID)) this.router.navigate(['migrate-to-polygon'])
    })

    this.navigationSubscription = this.navigationService.navigation$.subscribe(nav => {
      this.userNavigation = nav.user;
    })

    this.menuCollapsedSubscription = this.kSideMenuService.isCollapsed$.subscribe(v => {
      this.isMenuCollapsed = v;
    })

    this.userService.getReferralCode(this.userData.recordedWallet).pipe(first()).subscribe();
    this.checkCookieSession();

    this.authService.signinResponse$.subscribe(res => {
      this.analyticsService.setAnalyticsForLogin(res);
    });

    this.badgeService.getBadges(this.userData.recordedWallet).subscribe(badge => {
      this.hasEarlySupportBadge = badge.status_supporter;
      this.hasHunterBadge = badge.status_hunt;
    })

    //retrieve all company data from BE
    this.companyItemService.getAll().subscribe();
    this.companyItemService.companyItems$.subscribe(items => {
      this.companyItems = items;
      //initialize array for item focus
      this.companyItems.forEach(item => {
        this.ingameItemFocus.set(item.id, false);
      });
      this.getIbalanceItems();
    })


    //this.isWhitelistedAlready();

    //Create Invite for trainer
    this.web3Service.signStatus$.pipe(
      switchMap(signRes => {
        let trainerclub_status = signRes.get('trainer-club');
        if (trainerclub_status?.status === eStatus.success) {
          return this.badgeService.createInviteTrainer(trainerclub_status.value.result, this.userData.recordedWallet)
        } else return of(null);
      })).subscribe(item => {
        if (item) {
          localStorage.setItem('signature_uuid_trainer_invite', item.uuid);
          this.getLink();
        }
      });

    this.web3Service.signStatus$.pipe(
      switchMap(signRes => {
        let wok_status = signRes.get('wok-kogaea');
        if (wok_status?.status === eStatus.success) {
          let post = {
            walletId: this.userData.recordedWallet,
            email: this.userData.loginEmail,
            trainerClubId: this.trainerClubId,
            device: "na",
            signatureHash: wok_status.value.result
          }
          console.log(post);
          return this.http.post("https://api.kryptomon.co/wok-community/whitelistWok.php", post)
        } else return of(null);
      })).subscribe(item => {
        if (item) {
          this.whitelist(item)
        }
      });


  }


  ngOnDestroy(): void {
    this.navigationSubscription.unsubscribe();
    this.menuCollapsedSubscription.unsubscribe();
    this.userDataSubscription.unsubscribe();
  }

  onItemClick(item: INavigationItem) {
    console.log('navigation Item clicked', item)
  }

  logOut() {
    this.authService.signOut();
  }

  ngAfterViewChecked(): void {
    //move quick purchase container according to balance-item-container
    let quickPurchaseEl = document.getElementById('quick-purchase-container') as HTMLElement;
    if (quickPurchaseEl && innerWidth > 480) {
      let el = document.getElementById('balance-item-container');
      let l = el.getBoundingClientRect().left;
      quickPurchaseEl.style.left = l + 'px';
    }
    else if (quickPurchaseEl && innerWidth <= 480) {
      let quickPurchaseElWidth = quickPurchaseEl.getBoundingClientRect().width;
      quickPurchaseEl.style.left = 'calc(50% - ' + quickPurchaseElWidth / 2 + 'px);';
    }

    // let languageSwitchEl = document.getElementsByClassName('p-speeddial')[0] as HTMLElement;
    // let languageSwitchPosition = languageSwitchEl.getBoundingClientRect().height + 40;
    // let languageSwitchComponent = document.getElementById('languageSwitchID') as HTMLElement;
    // languageSwitchComponent.style.bottom = languageSwitchPosition + 'px';
    // if (this.isMenuCollapsed) languageSwitchComponent.style.bottom = languageSwitchPosition + 40 + 'px';
  }

  copyToClipboard(text: string) {

    navigator.clipboard.writeText(text).then(e => {
      this.toastService.add(
        {
          severity: 'info',
          summary: 'shared.copied',
          detail: 'toastMessage.walletCopied',
        });
    }).catch(e => console.error(e));
  }

  getIbalanceItems() {
    //SET STRUCTURE
    this.itemService.getLootboxItems(this.userData.recordedWallet).subscribe();
    this.balanceItems = this.balanceItemList.map(i => {
      return {
        ...this.companyItems.filter(item => item.id === i)[0],
        ...this.currencyItems.get(eCurrencies[i]),
        key: i
      }
    });
    //UPDATE BALANCE OF ITEMS
    this.itemService.lootboxItems$.subscribe((items: IUserLootboxItemsResponse[]) => {
      let _balancesItem = BALANCE_ITEM_LIST() as string[];
      //filter item from API to retrieve only item to show, esle [0].balance will throw an error.
      let navbarBalancesItem = items.filter(i => _balancesItem.includes(i.type));
      navbarBalancesItem.forEach(i => this.balanceItems.filter(bi => bi.key == i.type)[0].balance = i.count);
    });

    this.itemService.getNftItems(this.userData.recordedWallet).subscribe();
    this.itemService.nftItems$.subscribe((items:IUserNFTItemResponse[])=>{
      console.log(items)
      let filtered = items.filter(e=>e.metadata.name=="kmon-hunters-collectors-badge")
      if (filtered.length>0){
        this.hasCollectorBadge = true;
      }else{
        this.hasCollectorBadge = false
      }
      console.log(this.hasCollectorBadge)
    })
    //UPDATE POINTS
    this.userService.userRefCode$.subscribe(item => {
      this.balanceItems.filter(bi => bi.key == eCurrencies.POINTS)[0].balance = item.loyalty.programs.kryptomon_loyalty_prod.ledger.currentBalance;
    })
    //UPDATE KMON BALANCE
    this.tokenService.KMONbalance(this.userData.recordedWallet).pipe(first()).subscribe();
    this.tokenService.KMONBalance$.subscribe(value => {
      this.balanceItems.filter(bi => bi.key == eCurrencies.KMON)[0].balance = value.rounded;
    });
    //UPDATE BNB BALANCE
    this.web3Service.updateBalanceBnB(this.userData.recordedWallet);
    this.web3Service.balanceBnB$.subscribe(value => {
      this.balanceItems.filter(bi => bi.key == eCurrencies.BNB)[0].balance = value.rounded;
    });
    //UPDATE TICKET (CANDIES)
    this.stakingRewardsService.earned(this.userData.recordedWallet).pipe(first()).subscribe();
    this.stakingRewardsService.pointsBalance$.subscribe(value => {
      this.balanceItems.filter(bi => bi.key == eCurrencies.CANDIES)[0].balance = value.rounded;
    })
  }

  clearAllBalanceItemFocus() {
    [...this.ingameItemFocus.keys()].forEach((key) => {
      this.ingameItemFocus.set(key, false);
    });
  }
  goToPlay(event: { isMobile: boolean }) {
    if (event.isMobile) this.closeMenu();
    this.router.navigate(['play']);
  }

  goToWOK(event: { isMobile: boolean }) {
    if (event.isMobile) this.closeMenu();
    this.router.navigate(['wok']);
  }

  onBalanceItemClick(id: eCompanyItems | eCurrencies) {
    // console.log(id);
    if (Object.keys(eCompanyItems).includes(id)) {
      this.clearAllBalanceItemFocus();
      let nid = id as eCompanyItems;
      this.showQuickPurchase = true;
      this.ingameItemFocus.set(nid, true);
      // this.quickPurchaseItem = this.companyItems.get(nid);
      this.quickPurchaseItem = this.balanceItems.filter(i => i.id === id)[0];
    } else {
      switch (id) {
        case eCurrencies.BNB:
          this.router.navigate(['wallet']);
          break;
        case eCurrencies.KMON:
          this.router.navigate(['wallet']);
          break;
        case eCurrencies.POINTS:
          this.router.navigate(['referral']);
          break;
        case eCurrencies.CANDIES:
          this.router.navigate(['staking']);
          break;
        default:
          break;
      }
    }
  }

  checkCookieSession() {
    //its not necessary to clear cookieCheckInterval, because application will refresh
    //cookie check have not to work on play page
    this.cookieCheckInterval = setInterval(() => {
      if (!getCookieValue('recordedWallet') && this.router.url !== '/play') this.toastService.sessionExpired();
    }, 60000);
  }

  onSessionExpired() {
    location.reload();
  }

  closeMenu(): void {
    this.kSideMenuService.setCollapsed(true);
  }

  clickOutsideNavbar(event: boolean) {
    this.showQuickPurchase = event ? false : this.showQuickPurchase;
    if (event) this.clearAllBalanceItemFocus();
  }

  getLink() {
    let signature_uiid: string = localStorage.getItem('signature_uuid_trainer_invite');
    if (signature_uiid) {
      this.badgeService.retrieveTrainerInviteLink(signature_uiid).pipe(first()).subscribe(
        item => {
          if (item.status == 'done') window.open(item.inviteLink, '_blank')
          else this.toastService.genericError();
        }
      )
    } else {
      this.web3Service.signMessage(this.userData.recordedWallet, 'trainer-club', 'Join Trainer Club');
    }
  }

  whitelistWok() {
    this.web3Service.signMessage(this.userData.recordedWallet, "wok-kogaea", "Kogaea I'm coming!");

  }

  getNFT() {
    this.http.get("https://api-v2.kryptomon.co/user/" + this.userData.recordedWallet + "/nft-items?limit=1000").subscribe((responseNFT: any) => {
      console.log(responseNFT)
      for (let i = 0; i < responseNFT.length; i++) {
        if (responseNFT[i].metadata.name == "trainers-club-badge") {
          this.trainerClubId = responseNFT[i].itemId;
          break;
        }
      }

    }, (err) => {
      this.toastService.genericError()
    })
  }

  whitelist(item) {
    console.log(item)
    if (item.status == "done") {
      this.isWhitelisted = true;
      //this.buttonEnabled = false;
      if (this.trainerClubId !== undefined) {
        var club = 'yes';
      } else {
        var club = 'no';
      }
      analyticsTrack("whitelist trainerhub", {
        email: this.userData.loginEmail,
        ethAddress: this.userData.recordedWallet,
        trainerclub: club
      })
      setTimeout(() => {
        this.showWokBanner = false;
      }, 5000)
    } else {
      //error
      this.isLoading = false;
      this.toastService.genericError()
    }
  }

  isWhitelistedAlready() {
    let post = { walletId: this.userData.recordedWallet };
    this.http.post("https://api.kryptomon.co/wok-community/checkWhitelisting.php", post).subscribe((item: any) => {
      if (item.status) {
        this.showWokBanner = false;
      } else {
        this.getNFT()
        this.showWokBanner = true;
      }
    })
  }
  switchtoBNB(){
    window.localStorage.setItem("magicNetwork", environment.allowedNetwork[1])
    this.authService.signOut();
  }
}

//ORDER for Balance Item list
const BALANCE_ITEM_LIST = (): Array<eCompanyItems | eCurrencies> => {
  return [
    eCompanyItems.UNFREEZE_POTION,
    eCompanyItems.DIAMOND_STORY_CHEST,
    eCompanyItems.LOOTBOX_PREMIUM,
    eCompanyItems.LOOTBOX_MEDIUM,
    eCompanyItems.LOOTBOX_BASIC,
    eCurrencies.KMON,
    eCurrencies.BNB,
    eCurrencies.POINTS,
    eCurrencies.CANDIES
  ]
}